import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaPlus,
  FaShoppingCart,
  FaInfoCircle,
} from "react-icons/fa";
import ConfigService from "../services/ConfigService";

const MainPage = () => {
  const [serviceName, setServiceName] = useState('CartScheduler');
  const [homePageInfo, setHomePageInfo] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      const config = await ConfigService.loadConfig();
      setServiceName(config.serviceName || 'CartScheduler');
      if (config.homePageInfo && config.homePageInfo.enabled && config.homePageInfo.message && config.homePageInfo.message.trim()) {
        setHomePageInfo(config.homePageInfo);
      } else {
        setHomePageInfo(null);
      }
    };
    loadConfig();
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12 animate-fade-in">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Boka Vagn
          </h1>
          <p className="text-xl text-gray-600 mb-2">Norrköping Södra</p>
          <div className="w-24 h-1 bg-gradient-to-r from-primary-500 to-primary-700 mx-auto rounded-full"></div>
        </div>

        {/* Info Banner */}
        {homePageInfo && (
          <div className="card mb-6 bg-primary-50 border-l-4 border-primary-500 animate-fade-in">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <FaInfoCircle className="text-primary-600 text-xl mt-0.5" />
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-sm font-semibold text-primary-900 mb-1">
                  {homePageInfo.title || "Just nu"}
                </h3>
                <p className="text-sm text-primary-800 leading-relaxed">
                  {homePageInfo.message}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Action Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <DashboardCard
            to="/schedule"
            icon={<FaCalendarAlt className="text-4xl" />}
            title="Visa Schema"
            description="Se alla bokningar och tillgängliga tider"
            gradient="from-blue-500 to-blue-600"
            iconBg="bg-blue-100"
            iconColor="text-blue-600"
          />
          <DashboardCard
            to="/add-booking"
            icon={<FaPlus className="text-4xl" />}
            title="Ny Bokning"
            description="Skapa en ny bokning för vagn"
            gradient="from-primary-500 to-primary-600"
            iconBg="bg-primary-100"
            iconColor="text-primary-600"
          />
        </div>

        {/* Quick Info Card */}
        <div className="card animate-slide-up">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                <FaShoppingCart className="text-2xl text-primary-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Välkommen till {serviceName}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Här kan du enkelt boka vagnar för Norrköping Södra. 
                Se schemat för tillgängliga tider eller skapa en ny bokning direkt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DashboardCard = ({ to, icon, title, description, gradient, iconBg, iconColor }) => (
  <Link to={to} className="block group">
    <div className="card h-full hover:shadow-large transition-all duration-300 transform hover:-translate-y-1">
      <div className="flex flex-col items-center text-center">
        <div className={`${iconBg} w-20 h-20 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
          <div className={iconColor}>
            {icon}
          </div>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
        <div className={`mt-4 w-full h-1 bg-gradient-to-r ${gradient} rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300`}></div>
      </div>
    </div>
  </Link>
);

export default MainPage;
